import { AnalyticsEventLocation } from '@mb/lib';

interface IAnalyticsEvent {
  event: AnalyticsEventName;
  action?: AnalyticsEventAction | null;
  name?: string;
  event_location?: AnalyticsEventLocation | null;
  experiment_name?: string | null;
  experiment_version?: string | null;
  method?: AnalyticsEventMethod | null;
  list_id?: string | null;
  list_name?: string | null;
  type?: string | null;
  content_id?: string | null;
  content_type?: string | null;
}

export enum AnalyticsEventName {
  CAROUSEL = 'carousel',
  OPEN = 'open',
  ADD_TO_WISHLIST = 'add_to_wishlist',
  ADD_TO_CART = 'add_to_cart',
  SELECT_CONTENT = 'select_content',
  CLOSE = 'close',
}

export enum AnalyticsEventAction {
  FORWARD = 'Forward',
  BACK = 'Back',
}

export enum AnalyticsEventMethod {
  SINGLE_SELECT = 'Single',
  MULTI_SELECT = 'Multi-select',
  ADD_ALL = 'Add all',
}

export const sendAnalyticsEvent = (params: IAnalyticsEvent) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(params);
};
